import {
  ADD_SHORT_CRITIC,
  GET_SHORT_CRITIC,
  GET_SHORT_CRITIC_LIST,
  REMOVE_SHORT_CRITIC,
  UPDATE_SHORT_CRITIC,
} from '@jumbo/constants/ActionTypes';
import { client } from 'services/http';
import { fetchError, fetchStart, fetchSuccess } from './Common';

export const createShortCritic = (movieId, critic) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post(`/share/v1/movie/${movieId}/short_critics/`, critic)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('نقد شما با موفقیت ثبت شد'));
          dispatch({ type: ADD_SHORT_CRITIC, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const updateShortCritic = (movieId, critic) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`/share/v1/movie/${movieId}/short_critics/${critic.id}`, critic)
      .then(data => {
        if (data.status === 200 || data.status === 201) {
          dispatch(fetchSuccess('تغییرات با موفقیت اعمال شد'));
          dispatch({ type: UPDATE_SHORT_CRITIC, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getShortCritic = (movieId, criticId, history) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`/share/v1/movie/${movieId}/short_critics/${criticId}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_SHORT_CRITIC, payload: data.data });
          history.push(`/create-short-critic/?movie=${movieId}&critic=${criticId}`);
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getShortCriticList = movieId => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/movie/${movieId}/short_critics/`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_SHORT_CRITIC_LIST, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const deleteCritic = (movieId, criticId) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v1/movie/${movieId}/short_critics/${criticId}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: REMOVE_SHORT_CRITIC, payload: criticId });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};
